import { call } from 'redux-saga/effects';
import request from '../../../helpers/request';
import { RESEND_EMAIL, RECOVER_PASSWORD } from '../constants';
import notify from '../../../helpers/notify';
import { getHostDomain } from '../../../../utils/helperFunctions';

const recoverPasswordNotifier = (formValues, callback) => {
  const domain = getHostDomain();
  const { whiteBrand = '001' } =
    JSON.parse(localStorage.getItem(`conf-${domain}`)) || {};
  return notify({
    type: RECOVER_PASSWORD,
    formValues: { ...formValues, whiteBrand },
    callback,
  });
};

function* recoverPasswordAction({ formValues, callback }) {
  yield call(request, {
    type: RESEND_EMAIL,
    method: 'post',
    endpoint: '/users/recover-password',
    params: formValues,
    callback,
  });
}

export { recoverPasswordAction, recoverPasswordNotifier };
